import { render, staticRenderFns } from "./NavItemLeaf.vue?vue&type=template&id=04dc5747&name=nav-item-leaf&"
import script from "./NavItemLeaf.vue?vue&type=script&lang=js&"
export * from "./NavItemLeaf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports